<app-error-page title="Error 400" actionText="Go to Home page" (onAction)="navigateToStartPage()">
    <p>Bad request.</p>
    <p class="mb-30">Please check the URL address or</p>
</app-error-page>
